import { useTranslation } from "react-i18next";
import Spinner from "@/components/Spinner";
import { AgreementLoadingReason } from "../../context";

interface AgreementLoaderProps {
  reason: AgreementLoadingReason;
}

export const AgreementLoader = ({ reason }: AgreementLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center h-64 space-y-4">
      <Spinner />
      <p className="text-sm text-muted-foreground">
        {t("agreements.loadingStates." + reason)}
      </p>
    </div>
  );
};
